import { render, staticRenderFns } from "./annotationList.vue?vue&type=template&id=063fae16&scoped=true"
import script from "./annotationList.vue?vue&type=script&lang=js"
export * from "./annotationList.vue?vue&type=script&lang=js"
import style0 from "./annotationList.vue?vue&type=style&index=0&id=063fae16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063fae16",
  null
  
)

export default component.exports